import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  CompanyTitleChanged,
  CountryChanged,
  CreateNewCompany,
  CreateSchema,
  DefaultCountryChanged,
  ExistingCompanyChanged,
  HideCreateNewCompany,
  MaximumWKBatchSizeChanged,
  MinimumWKBatchSizeChanged,
  NewCompany,
  NexusAccountChanged,
  PasswordChanged,
  PasswordVerificationChanged,
  RedemptionThresholdChanged,
  RedemptionTypeChanged,
  SchemaCodeChanged,
  SchemaLevelChanged,
  SchemaNameChanged,
  TaxOfficeChanged,
  TicketForwardingEmailChanged,
  TicketSenderNameChanged,
  UpdateSchema,
  UsesInvoicesChanged,
  UsesPrintedCardsChanged,
  VATNumberChanged,
  WebSiteChanged,
  WelcomeEmailChanged,
} from '../actions/create-new.actions';
import { CloseEditSchema, EditSchema } from '../actions/search.actions';
import { SchemasCreateNewState } from '../models/schemas.model';

const initialState: SchemasCreateNewState = {
  isUpdate: false,
  schemaName: '',
  schemaCode: '',
  defaultCountryOptions: [],
  defaultCountry: 0,
  newCompany: false,
  newCompanySaved: false,
  existingCompanyOptions: [],
  existingCompany: 0,
  companyTitle: '',
  countryOptions: [],
  country: 0,
  taxOffice: '',
  vatNumber: '',
  webSite: '',
  schemaLevelOptions: [],
  schemaLevel: 0,
  nexusAccountOptions: [],
  nexusAccount: 0,
  redemptionTypeOptions: [],
  redemptionType: 0,
  redemptionThreshold: '',
  usesPrintedCards: false,
  usesInvoices: false,
  ticketForwardingEmail: '',
  ticketSenderName: '',
  welcomeEmail: '',
  minimumWKBatchSize: '',
  maximumWKBatchSize: '',
  password: '',
  passwordVerification: '',
  submit: false,
};

export const SchemasCreateNewReducer = createReducer(
  initialState,
  on(EditSchema, (state, { row }) => ({
    ...state,
    isUpdate: true,
    schemaName: row.loyaltySchemaName,
    schemaCode: row.loyaltySchemaCode,
    schemaLevel: row.tableLoyaltySchemaLevelId,
    defaultCountry: row.tableCountryId,
    nexusAccount: row.nexusAccountId,
    redemptionType: row.tableLoyaltySchemaRedemptionTypeId,
    usesPrintedCards: row.usesPrintedCards,
    usesInvoices: row.usesInvoices,
    ticketForwardingEmail: row.ticketForwardEmail,
    ticketSenderName: row.ticketSenderName,
    welcomeEmail: row.wkNotificationEmail,
    minimumWKBatchSize: String(row.minimumWKBatchSize),
    maximumWKBatchSize: String(row.maximumWKBatchSize),
  })),

  on(SchemaNameChanged, (state, { schemaName }) => ({
    ...state,
    schemaName,
  })),
  on(SchemaCodeChanged, (state, { schemaCode }) => ({
    ...state,
    schemaCode,
  })),
  on(DefaultCountryChanged, (state, { defaultCountry }) => ({
    ...state,
    defaultCountry,
  })),
  on(ExistingCompanyChanged, (state, { existingCompany }) => ({
    ...state,
    existingCompany,
  })),
  on(NewCompany, (state) => ({
    ...state,
    newCompanySaved: true,
  })),
  on(CompanyTitleChanged, (state, { companyTitle }) => ({
    ...state,
    companyTitle,
  })),
  on(CountryChanged, (state, { country }) => ({
    ...state,
    country,
  })),
  on(TaxOfficeChanged, (state, { taxOffice }) => ({
    ...state,
    taxOffice,
  })),
  on(VATNumberChanged, (state, { vatNumber }) => ({
    ...state,
    vatNumber,
  })),
  on(WebSiteChanged, (state, { webSite }) => ({
    ...state,
    webSite,
  })),
  on(SchemaLevelChanged, (state, { schemaLevel }) => ({
    ...state,
    schemaLevel: schemaLevel ? schemaLevel : null,
  })),
  on(NexusAccountChanged, (state, { nexusAccount }) => ({
    ...state,
    nexusAccount: nexusAccount ? nexusAccount : null,
  })),
  on(RedemptionTypeChanged, (state, { redemptionType }) => ({
    ...state,
    redemptionType: redemptionType ? redemptionType : null,
  })),
  on(RedemptionThresholdChanged, (state, { redemptionThreshold }) => ({
    ...state,
    redemptionThreshold,
  })),
  on(UsesPrintedCardsChanged, (state) => ({
    ...state,
    usesPrintedCards: !state.usesPrintedCards,
  })),
  on(UsesInvoicesChanged, (state) => ({
    ...state,
    usesInvoices: !state.usesInvoices,
  })),
  on(TicketForwardingEmailChanged, (state, { ticketForwardingEmail }) => ({
    ...state,
    ticketForwardingEmail,
  })),
  on(TicketSenderNameChanged, (state, { ticketSenderName }) => ({
    ...state,
    ticketSenderName,
  })),
  on(WelcomeEmailChanged, (state, { welcomeEmail }) => ({
    ...state,
    welcomeEmail,
  })),
  on(MinimumWKBatchSizeChanged, (state, { minimumWKBatchSize }) => ({
    ...state,
    minimumWKBatchSize,
  })),
  on(MaximumWKBatchSizeChanged, (state, { maximumWKBatchSize }) => ({
    ...state,
    maximumWKBatchSize,
  })),
  on(PasswordChanged, (state, { password }) => ({
    ...state,
    password,
  })),
  on(PasswordVerificationChanged, (state, { passwordVerification }) => ({
    ...state,
    passwordVerification,
  })),
  on(CreateNewCompany, (state) => ({
    ...state,
    newCompany: true,
  })),
  on(HideCreateNewCompany, (state) => ({
    ...state,
    newCompany: false,
    newCompanySaved: false,
    companyTitle: '',
    country: 0,
    taxOffice: '',
    vatNumber: '',
    webSite: '',
  })),
  on(CreateSchema, UpdateSchema, (state) => ({
    ...state,
    submit: true,
  })),
  on(ActiveComponentChanged, CloseEditSchema, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
